const NAMED_ENTITIES: Record<string, string> = {
    amp: '&',
    lt: '<',
    gt: '>',
    quot: '"',
    apos: "'",
    nbsp: ' ',
    ndash: '–',
    mdash: '—',
    hellip: '…',
    lsquo: '‘',
    rsquo: '’',
    ldquo: '“',
    rdquo: '”',
};

/**
 * Decode HTML entities (named + numeric) in a plain-text string. SSR-safe — no
 * DOM — so it runs the same in the loader and the browser.
 */
const decodeEntities = (text: string): string =>
    text.replace(/&(#x?[0-9a-f]+|[a-z][a-z0-9]*);/gi, (match, code: string) => {
        if (code[0] === '#') {
            const isHex = code[1] === 'x' || code[1] === 'X';
            const codePoint = parseInt(
                isHex ? code.slice(2) : code.slice(1),
                isHex ? 16 : 10,
            );
            return Number.isNaN(codePoint)
                ? match
                : String.fromCodePoint(codePoint);
        }
        return NAMED_ENTITIES[code.toLowerCase()] ?? match;
    });

/** Strips HTML tags from a CMS rich-text value down to a single plain-text line. */
export const stripHtml = (html: string): string =>
    decodeEntities(html.replace(/<[^>]*>/g, ' '))
        .replace(/\s+/g, ' ')
        .trim();
